import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const faqs = [
  {
    q: "What types of brands do you work with?",
    a: "We work with founders, creators, experts, investors, coaches, entrepreneurs, startups, and established companies seeking premium visibility, authority, and strategic growth.",
  },
  {
    q: "Do you guarantee media placements?",
    a: "Media placement depends on editorial fit, story strength, timing, media availability, and campaign strategy. We focus on building strong positioning and pursuing relevant, high-value opportunities.",
  },
  {
    q: "Can you support bilingual campaigns?",
    a: "Yes. NOVA Media PR can support English, Spanish, and bilingual visibility strategies for U.S., LATAM, and Hispanic-market audiences.",
  },
  {
    q: "What is the investment?",
    a: "Investment depends on the campaign scope, number of outlets, type of services, level of strategy, and duration. Custom proposals are created after an initial consultation.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative bg-[#080808] py-16 md:py-24 lg:py-32 border-y border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 mb-8 md:mb-12 lg:mb-16">
          <div className="col-span-12 md:col-span-3">
            <span className="text-[10px] uppercase tracking-[0.35em] text-[#7FB3D5]">
              ✦ FAQ
            </span>
            <p className="mt-6 text-[10px] uppercase tracking-[0.3em] text-white/40">
              Page 08
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2
              data-testid="faq-headline"
              className="font-display text-4xl md:text-6xl lg:text-7xl text-white leading-[0.95] tracking-tight font-light"
            >
              Common
              <span className="italic text-[#7FB3D5]"> questions</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          <div className="hidden md:block col-span-3" />
          <div className="col-span-12 md:col-span-9 border-t border-white/10">
            {faqs.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={idx}
                  data-testid={`faq-item-${idx}`}
                  className={`border-b border-white/10 transition-colors duration-500 ${
                    isOpen ? "bg-white/[0.02]" : ""
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    data-testid={`faq-toggle-${idx}`}
                    aria-expanded={isOpen}
                    className="w-full flex items-start justify-between gap-6 py-7 md:py-9 text-left group"
                  >
                    <h3 className="font-display text-xl md:text-3xl text-white font-light leading-snug">
                      {item.q}
                    </h3>
                    <span
                      className={`shrink-0 w-10 h-10 rounded-full border flex items-center justify-center transition-all duration-500 ${
                        isOpen
                          ? "border-[#7FB3D5] bg-[#7FB3D5] text-black"
                          : "border-white/20 text-white/60 group-hover:border-[#7FB3D5] group-hover:text-[#7FB3D5]"
                      }`}
                    >
                      {isOpen ? (
                        <Minus className="w-4 h-4" strokeWidth={1.5} />
                      ) : (
                        <Plus className="w-4 h-4" strokeWidth={1.5} />
                      )}
                    </span>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-700 ${
                      isOpen ? "max-h-96 opacity-100 pb-8" : "max-h-0 opacity-0"
                    }`}
                  >
                    <p className="text-base md:text-lg text-white/65 leading-relaxed max-w-3xl">
                      {item.a}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
